export enum PayloadTypes {
  int='INT',
  float='FLOAT',
  json='JSON'
}
